const validators = {
    // Valida que el string no esté vacío ni tenga solo espacios
    required: (value) => {
      if (value === undefined || value === null) return false;
      return value.toString().trim().length > 0;
    },
  
    // Valida que el string tenga al menos una longitud mínima
    minLength: (value, min) => {
      if (value === undefined || value === null) return false;
      return value.toString().trim().length >= min;
    },
  
    // Valida que el string tenga como máximo la longitud indicada
    maxLength: (value, max) => {
      if (value === undefined || value === null) return false;
      return value.toString().trim().length <= max;
    },
  
    // Valida que el valor sea un número
    isNumber: (value) => {
      if (value === undefined || value === null) return false;
      return !isNaN(Number(value));
    },
  
    // Valida que el valor sea un entero
    isInteger: (value) => {
      if (value === undefined || value === null) return false;
      return Number.isInteger(Number(value));
    },
  
    // Valida que el string tenga formato de email básico
    isEmail: (value) => {
      if (typeof value !== 'string') return false;
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(value.trim());
    },
  
    // Valida que el string tenga formato de URL básico
    isURL: (value) => {
      if (typeof value !== 'string') return false;
      try {
        new URL(value);
        return true;
      } catch {
        return false;
      }
    },
  
    // Valida que un string contenga solo letras (sin espacios ni números)
    isAlpha: (value) => {
      if (typeof value !== 'string') return false;
      return /^[a-zA-Z]+$/.test(value.trim());
    },
  
    // Valida que un string contenga solo letras y espacios
    isAlphaWithSpaces: (value) => {
      if (typeof value !== 'string') return false;
      return /^[a-zA-Z\s]+$/.test(value.trim());
    },
  
    // Valida que el string contenga solo números
    isNumeric: (value) => {
      if (typeof value !== 'string' && typeof value !== 'number') return false;
      return /^[0-9]+$/.test(value.toString());
    },
  
    // Valida que un string sea una fecha válida (ISO, yyyy-mm-dd o similar)
    isDate: (value) => {
      if (typeof value !== 'string') return false;
      const date = new Date(value);
      return !isNaN(date.getTime());
    },
  
    // Valida que un valor esté entre min y max (numérico)
    isBetween: (value, min, max) => {
      const num = Number(value);
      if (isNaN(num)) return false;
      return num >= min && num <= max;
    },
  };
  
  export default validators;
  